export default __webpack_public_path__ + "static/media/icon_logo.27461793.svg";